"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "vcm" };
var _hoisted_2 = { class: "vcm-header" };
var _hoisted_3 = { class: "vcm-lookup" };
var _hoisted_4 = {
    key: 0,
    class: "lookup-field"
};
var _hoisted_5 = ["value"];
var _hoisted_6 = { class: "lookup-field" };
var _hoisted_7 = ["value"];
var _hoisted_8 = {
    key: 1,
    class: "lookup-field"
};
var _hoisted_9 = ["value"];
var _hoisted_10 = {
    key: 2,
    class: "lookup-field"
};
var _hoisted_11 = ["value"];
var _hoisted_12 = { class: "result-icon" };
var _hoisted_13 = {
    key: 0,
    class: "result-notes"
};
var _hoisted_14 = { class: "vcm-tabs" };
var _hoisted_15 = ["onClick"];
var _hoisted_16 = { class: "vcm-table-wrap" };
var _hoisted_17 = {
    key: 0,
    class: "vcm-table"
};
var _hoisted_18 = { class: "row-header" };
var _hoisted_19 = { class: "cell-icon" };
var _hoisted_20 = {
    key: 1,
    class: "vcm-table"
};
var _hoisted_21 = { class: "row-header" };
var _hoisted_22 = { class: "cell-icon" };
var _hoisted_23 = {
    key: 2,
    class: "vcm-table"
};
var _hoisted_24 = { class: "row-header abbr-col" };
var _hoisted_25 = { class: "cell-icon" };
var vue_3 = require("vue");
var appointmentApiService_1 = require("../../../services/appointmentApiService");
/* ── Tabs ────────────────────────────────────────────────────────── */
exports.default = (0, vue_1.defineComponent)({
    __name: 'VisitCompatibilityMatrix',
    setup: function (__props) {
        var TABS = [
            { value: 'patient-context', label: 'Patient × Context' },
            { value: 'caregiver-context', label: 'Caregiver × Context' },
            { value: 'caregiver-caregiver', label: 'Caregiver × Caregiver' }
        ];
        var activeTab = (0, vue_3.ref)('patient-context');
        /* ── Selection state ─────────────────────────────────────────────── */
        var sel = (0, vue_3.reactive)({
            patientCtx: 'Meals & Nutrition',
            caregiverTypeA: 'pt',
            caregiverTypeB: 'rn',
            caregiverCtx: 'In-Home'
        });
        /* ── Display helpers ─────────────────────────────────────────────── */
        var cellIcon = { yes: '✓', conditional: '!', no: '×' };
        var resultIcon = { yes: '✓', conditional: '!', no: '×' };
        var resultLabel = {
            yes: 'Compatible',
            conditional: 'Conditional — rules apply',
            no: 'Incompatible'
        };
        function strictest() {
            var vals = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                vals[_i] = arguments[_i];
            }
            return vals.reduce(function (a, b) { return appointmentApiService_1.ORDER[a] <= appointmentApiService_1.ORDER[b] ? a : b; });
        }
        /* ── Notes per combination ───────────────────────────────────────── */
        function patientContextNotes(pCtx, cCtx, cType) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            var m1 = (_b = (_a = appointmentApiService_1.patientContextViability[pCtx]) === null || _a === void 0 ? void 0 : _a[cCtx]) !== null && _b !== void 0 ? _b : 'no';
            var m2 = (_d = (_c = appointmentApiService_1.caregiverContextCompat[cType]) === null || _c === void 0 ? void 0 : _c[cCtx]) !== null && _d !== void 0 ? _d : 'no';
            var notes = [];
            if (m1 === 'conditional') {
                notes.push("".concat(cCtx, " visit is conditional while patient context is \"").concat(pCtx, "\" \u2014 privacy and safety rules apply."));
            }
            if (m1 === 'no' && pCtx === 'Out of Home') {
                notes.push("Patient is out of home \u2014 in-person in-home visits are blocked; escort, facility, or telehealth only.");
            }
            if (m1 === 'no' && pCtx === 'Unavailable / Private') {
                notes.push("Patient has marked this time as private \u2014 ".concat(cCtx, " visits are not permitted."));
            }
            if (m2 === 'conditional') {
                var typeLabel = (_f = (_e = appointmentApiService_1.CAREGIVER_TYPES.find(function (t) { return t.key === cType; })) === null || _e === void 0 ? void 0 : _e.label) !== null && _f !== void 0 ? _f : cType;
                notes.push("".concat(typeLabel, " operates conditionally in the ").concat(cCtx, " context \u2014 coordination or prior approval required."));
            }
            if (m2 === 'no') {
                var typeLabel = (_h = (_g = appointmentApiService_1.CAREGIVER_TYPES.find(function (t) { return t.key === cType; })) === null || _g === void 0 ? void 0 : _g.label) !== null && _h !== void 0 ? _h : cType;
                notes.push("".concat(typeLabel, " does not operate in the ").concat(cCtx, " context."));
            }
            if (notes.length === 0 && m1 === 'yes' && m2 === 'yes') {
                notes.push('This combination is fully compatible — no restrictions apply.');
            }
            return notes;
        }
        function caregiverContextNotes(cType, cCtx) {
            var _a, _b, _c, _d;
            var m2 = (_b = (_a = appointmentApiService_1.caregiverContextCompat[cType]) === null || _a === void 0 ? void 0 : _a[cCtx]) !== null && _b !== void 0 ? _b : 'no';
            var typeLabel = (_d = (_c = appointmentApiService_1.CAREGIVER_TYPES.find(function (t) { return t.key === cType; })) === null || _c === void 0 ? void 0 : _c.label) !== null && _d !== void 0 ? _d : cType;
            if (m2 === 'yes')
                return ["".concat(typeLabel, " is fully authorized for ").concat(cCtx, " visits.")];
            if (m2 === 'conditional')
                return ["".concat(typeLabel, " may work in the ").concat(cCtx, " context with coordination or supervisor approval.")];
            return ["".concat(typeLabel, " is not authorized to operate in the ").concat(cCtx, " context.")];
        }
        function caregiverPairNotes(typeA, typeB) {
            var _a, _b, _c, _d, _e, _f;
            var m3 = (_b = (_a = appointmentApiService_1.caregiverPairCompat[typeA]) === null || _a === void 0 ? void 0 : _a[typeB]) !== null && _b !== void 0 ? _b : 'no';
            var labelA = (_d = (_c = appointmentApiService_1.CAREGIVER_TYPES.find(function (t) { return t.key === typeA; })) === null || _c === void 0 ? void 0 : _c.label) !== null && _d !== void 0 ? _d : typeA;
            var labelB = (_f = (_e = appointmentApiService_1.CAREGIVER_TYPES.find(function (t) { return t.key === typeB; })) === null || _e === void 0 ? void 0 : _e.label) !== null && _f !== void 0 ? _f : typeB;
            if (typeA === typeB)
                return ["Same discipline \u2014 parallel visits allowed but coordinate to avoid duplication."];
            if (m3 === 'yes')
                return ["".concat(labelA, " and ").concat(labelB, " can see the same patient simultaneously without restrictions.")];
            if (m3 === 'conditional')
                return ["".concat(labelA, " and ").concat(labelB, " parallel visits require privacy coordination \u2014 confirm patient consent before scheduling both in the same window.")];
            return ["".concat(labelA, " and ").concat(labelB, " cannot see the same patient simultaneously \u2014 scheduling conflict will block the second booking.")];
        }
        /* ── Live lookup result ──────────────────────────────────────────── */
        var lookupResult = (0, vue_3.computed)(function () {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            if (activeTab.value === 'patient-context') {
                var m1 = (_b = (_a = appointmentApiService_1.patientContextViability[sel.patientCtx]) === null || _a === void 0 ? void 0 : _a[sel.caregiverCtx]) !== null && _b !== void 0 ? _b : 'no';
                var m2 = (_d = (_c = appointmentApiService_1.caregiverContextCompat[sel.caregiverTypeA]) === null || _c === void 0 ? void 0 : _c[sel.caregiverCtx]) !== null && _d !== void 0 ? _d : 'no';
                var level_1 = strictest(m1, m2);
                return { level: level_1, notes: patientContextNotes(sel.patientCtx, sel.caregiverCtx, sel.caregiverTypeA) };
            }
            if (activeTab.value === 'caregiver-context') {
                var level_2 = (_f = (_e = appointmentApiService_1.caregiverContextCompat[sel.caregiverTypeA]) === null || _e === void 0 ? void 0 : _e[sel.caregiverCtx]) !== null && _f !== void 0 ? _f : 'no';
                return { level: level_2, notes: caregiverContextNotes(sel.caregiverTypeA, sel.caregiverCtx) };
            }
            // caregiver-caregiver
            var level = (_h = (_g = appointmentApiService_1.caregiverPairCompat[sel.caregiverTypeA]) === null || _g === void 0 ? void 0 : _g[sel.caregiverTypeB]) !== null && _h !== void 0 ? _h : 'no';
            return { level: level, notes: caregiverPairNotes(sel.caregiverTypeA, sel.caregiverTypeB) };
        });
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    _cache[7] || (_cache[7] = (0, vue_2.createElementVNode)("div", { class: "vcm-title-row" }, [
                        (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-grid-3x3-gap-fill vcm-icon" }),
                        (0, vue_2.createElementVNode)("div", null, [
                            (0, vue_2.createElementVNode)("h3", null, "Visit Compatibility Reference"),
                            (0, vue_2.createElementVNode)("p", null, "Rules the master calendar will enforce for parallel visits")
                        ])
                    ], -1)),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (activeTab.value !== 'caregiver-caregiver')
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_4, [
                                _cache[4] || (_cache[4] = (0, vue_2.createElementVNode)("label", null, "Patient Context", -1)),
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((sel.patientCtx) = $event); }),
                                    class: "vcm-select"
                                }, [
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(appointmentApiService_1.PATIENT_CONTEXTS), function (c) {
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                            key: c,
                                            value: c
                                        }, (0, vue_2.toDisplayString)(c), 9, _hoisted_5));
                                    }), 128))
                                ], 512), [
                                    [vue_2.vModelSelect, sel.patientCtx]
                                ])
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createElementVNode)("div", _hoisted_6, [
                            (0, vue_2.createElementVNode)("label", null, (0, vue_2.toDisplayString)(activeTab.value === 'caregiver-caregiver' ? 'Caregiver A' : 'Caregiver Type'), 1),
                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((sel.caregiverTypeA) = $event); }),
                                class: "vcm-select"
                            }, [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(appointmentApiService_1.CAREGIVER_TYPES), function (t) {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                        key: t.key,
                                        value: t.key
                                    }, (0, vue_2.toDisplayString)(t.label), 9, _hoisted_7));
                                }), 128))
                            ], 512), [
                                [vue_2.vModelSelect, sel.caregiverTypeA]
                            ])
                        ]),
                        (activeTab.value === 'caregiver-caregiver')
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_8, [
                                _cache[5] || (_cache[5] = (0, vue_2.createElementVNode)("label", null, "Caregiver B", -1)),
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((sel.caregiverTypeB) = $event); }),
                                    class: "vcm-select"
                                }, [
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(appointmentApiService_1.CAREGIVER_TYPES), function (t) {
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                            key: t.key,
                                            value: t.key
                                        }, (0, vue_2.toDisplayString)(t.label), 9, _hoisted_9));
                                    }), 128))
                                ], 512), [
                                    [vue_2.vModelSelect, sel.caregiverTypeB]
                                ])
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (activeTab.value !== 'caregiver-caregiver')
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_10, [
                                _cache[6] || (_cache[6] = (0, vue_2.createElementVNode)("label", null, "Caregiver Context", -1)),
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return ((sel.caregiverCtx) = $event); }),
                                    class: "vcm-select"
                                }, [
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(appointmentApiService_1.CAREGIVER_CONTEXTS), function (c) {
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                            key: c,
                                            value: c
                                        }, (0, vue_2.toDisplayString)(c), 9, _hoisted_11));
                                    }), 128))
                                ], 512), [
                                    [vue_2.vModelSelect, sel.caregiverCtx]
                                ])
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createElementVNode)("div", {
                            class: (0, vue_2.normalizeClass)(["result-card", lookupResult.value.level])
                        }, [
                            (0, vue_2.createElementVNode)("span", _hoisted_12, (0, vue_2.toDisplayString)(resultIcon[lookupResult.value.level]), 1),
                            (0, vue_2.createElementVNode)("div", null, [
                                (0, vue_2.createElementVNode)("strong", null, (0, vue_2.toDisplayString)(resultLabel[lookupResult.value.level]), 1),
                                (lookupResult.value.notes.length)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("ul", _hoisted_13, [
                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(lookupResult.value.notes, function (note) {
                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", { key: note }, (0, vue_2.toDisplayString)(note), 1));
                                        }), 128))
                                    ]))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ])
                        ], 2)
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_14, [
                    ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(TABS, function (tab) {
                        return (0, vue_2.createElementVNode)("button", {
                            key: tab.value,
                            class: (0, vue_2.normalizeClass)(['vcm-tab', { active: activeTab.value === tab.value }]),
                            onClick: function ($event) { return (activeTab.value = tab.value); }
                        }, (0, vue_2.toDisplayString)(tab.label), 11, _hoisted_15);
                    }), 64))
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_16, [
                    (activeTab.value === 'patient-context')
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("table", _hoisted_17, [
                            (0, vue_2.createElementVNode)("thead", null, [
                                (0, vue_2.createElementVNode)("tr", null, [
                                    _cache[8] || (_cache[8] = (0, vue_2.createElementVNode)("th", { class: "row-header" }, "Patient ↓ / Context →", -1)),
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(appointmentApiService_1.CAREGIVER_CONTEXTS), function (ctx) {
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("th", { key: ctx }, (0, vue_2.toDisplayString)(ctx), 1));
                                    }), 128))
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("tbody", null, [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(appointmentApiService_1.PATIENT_CONTEXTS), function (pCtx) {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", {
                                        key: pCtx,
                                        class: (0, vue_2.normalizeClass)({ 'highlight-row': pCtx === sel.patientCtx })
                                    }, [
                                        (0, vue_2.createElementVNode)("td", _hoisted_18, (0, vue_2.toDisplayString)(pCtx), 1),
                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(appointmentApiService_1.CAREGIVER_CONTEXTS), function (cCtx) {
                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", {
                                                key: cCtx,
                                                class: (0, vue_2.normalizeClass)(['cell', (0, vue_2.unref)(appointmentApiService_1.patientContextViability)[pCtx][cCtx],
                                                    { 'highlight-col': cCtx === sel.caregiverCtx,
                                                        'highlight-cell': pCtx === sel.patientCtx && cCtx === sel.caregiverCtx }])
                                            }, [
                                                (0, vue_2.createElementVNode)("span", _hoisted_19, (0, vue_2.toDisplayString)(cellIcon[(0, vue_2.unref)(appointmentApiService_1.patientContextViability)[pCtx][cCtx]]), 1)
                                            ], 2));
                                        }), 128))
                                    ], 2));
                                }), 128))
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (activeTab.value === 'caregiver-context')
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("table", _hoisted_20, [
                            (0, vue_2.createElementVNode)("thead", null, [
                                (0, vue_2.createElementVNode)("tr", null, [
                                    _cache[9] || (_cache[9] = (0, vue_2.createElementVNode)("th", { class: "row-header" }, "Caregiver type ↓ / Context →", -1)),
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(appointmentApiService_1.CAREGIVER_CONTEXTS), function (ctx) {
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("th", { key: ctx }, (0, vue_2.toDisplayString)(ctx), 1));
                                    }), 128))
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("tbody", null, [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(appointmentApiService_1.CAREGIVER_TYPES), function (t) {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", {
                                        key: t.key,
                                        class: (0, vue_2.normalizeClass)({ 'highlight-row': t.key === sel.caregiverTypeA })
                                    }, [
                                        (0, vue_2.createElementVNode)("td", _hoisted_21, (0, vue_2.toDisplayString)(t.label), 1),
                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(appointmentApiService_1.CAREGIVER_CONTEXTS), function (cCtx) {
                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", {
                                                key: cCtx,
                                                class: (0, vue_2.normalizeClass)(['cell', (0, vue_2.unref)(appointmentApiService_1.caregiverContextCompat)[t.key][cCtx],
                                                    { 'highlight-col': cCtx === sel.caregiverCtx,
                                                        'highlight-cell': t.key === sel.caregiverTypeA && cCtx === sel.caregiverCtx }])
                                            }, [
                                                (0, vue_2.createElementVNode)("span", _hoisted_22, (0, vue_2.toDisplayString)(cellIcon[(0, vue_2.unref)(appointmentApiService_1.caregiverContextCompat)[t.key][cCtx]]), 1)
                                            ], 2));
                                        }), 128))
                                    ], 2));
                                }), 128))
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (activeTab.value === 'caregiver-caregiver')
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("table", _hoisted_23, [
                            (0, vue_2.createElementVNode)("thead", null, [
                                (0, vue_2.createElementVNode)("tr", null, [
                                    _cache[10] || (_cache[10] = (0, vue_2.createElementVNode)("th", { class: "row-header" }, "↓ \\ →", -1)),
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(appointmentApiService_1.CAREGIVER_TYPES), function (t) {
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("th", {
                                            key: t.key,
                                            class: "abbr-col"
                                        }, (0, vue_2.toDisplayString)(t.abbr), 1));
                                    }), 128))
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("tbody", null, [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(appointmentApiService_1.CAREGIVER_TYPES), function (rowT) {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", {
                                        key: rowT.key,
                                        class: (0, vue_2.normalizeClass)({ 'highlight-row': rowT.key === sel.caregiverTypeA || rowT.key === sel.caregiverTypeB })
                                    }, [
                                        (0, vue_2.createElementVNode)("td", _hoisted_24, (0, vue_2.toDisplayString)(rowT.abbr), 1),
                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(appointmentApiService_1.CAREGIVER_TYPES), function (colT) {
                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", {
                                                key: colT.key,
                                                class: (0, vue_2.normalizeClass)(['cell', (0, vue_2.unref)(appointmentApiService_1.caregiverPairCompat)[rowT.key][colT.key],
                                                    { 'highlight-col': colT.key === sel.caregiverTypeA || colT.key === sel.caregiverTypeB,
                                                        'highlight-cell': (rowT.key === sel.caregiverTypeA && colT.key === sel.caregiverTypeB) ||
                                                            (rowT.key === sel.caregiverTypeB && colT.key === sel.caregiverTypeA) }])
                                            }, [
                                                (0, vue_2.createElementVNode)("span", _hoisted_25, (0, vue_2.toDisplayString)(cellIcon[(0, vue_2.unref)(appointmentApiService_1.caregiverPairCompat)[rowT.key][colT.key]]), 1)
                                            ], 2));
                                        }), 128))
                                    ], 2));
                                }), 128))
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ]),
                _cache[11] || (_cache[11] = (0, vue_2.createStaticVNode)("<div class=\"vcm-legend\" data-v-561ed30d><span class=\"legend-item yes\" data-v-561ed30d><span class=\"ld\" data-v-561ed30d></span> Compatible</span><span class=\"legend-item conditional\" data-v-561ed30d><span class=\"ld\" data-v-561ed30d></span> Conditional</span><span class=\"legend-item no\" data-v-561ed30d><span class=\"ld\" data-v-561ed30d></span> Incompatible</span></div>", 1))
            ]));
        };
    }
});
